"use client";
import React, { useEffect, useState } from "react";
import { Image } from "antd";
import { useSearchParams } from "next/navigation";
import "./VoiceAgentButton.scss";
import VoiceAgentPanel from "@/components/VoiceAgent/VoiceAgentPanel";
import robotLogo from "../../assets/images/defaultImages/robot.jpg";

const VoiceAgentButton = () => {
  const searchParams = useSearchParams();
  const [isMounted, setIsMounted] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  // ?voice_agent=1 keeps the OpenAI agent. ?voice_agent=v2 uses ElevenLabs.
  const voiceAgentParam = String(searchParams?.get("voice_agent") || "").toLowerCase();
  const engine = voiceAgentParam === "v2" ? "v2" : "openai";
  const engineLabel = engine === "v2" ? "V2 working" : "OpenAI working";
  const showVoiceAgent =
    engine === "v2" || ["1", "true", "yes"].includes(voiceAgentParam);

  useEffect(() => {
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  // Close drawer if query param is removed
  useEffect(() => {
    if (!showVoiceAgent && (isOpen || isMounted)) {
      setIsOpen(false);
      document.body.style.overflow = "";
      setIsMounted(false);
    }
  }, [showVoiceAgent, isOpen, isMounted]);

  const openDrawer = () => {
    setIsMounted(true);
    document.body.style.overflow = "hidden";
    // Next frame so CSS can animate from translateY(100%) → 0
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setIsOpen(true));
    });
  };

  const closeDrawer = () => {
    setIsOpen(false);
    document.body.style.overflow = "";
    // Wait for slide-down animation before unmounting
    window.setTimeout(() => setIsMounted(false), 320);
  };

  const toggleDrawer = () => {
    if (isOpen || isMounted) {
      closeDrawer();
    } else {
      openDrawer();
    }
  };

  if (!showVoiceAgent) {
    return null;
  }

  return (
    <>
      <div className="voice-agent-widget">
        <span className={`voice-agent-engine voice-agent-engine--${engine}`}>
          {engineLabel}
        </span>
        <button
          className={`voice-agent-button${isOpen ? " active" : ""}`}
          onClick={toggleDrawer}
          aria-label={`Open voice agent, ${engineLabel}`}
          title={engineLabel}
          type="button"
        >
          <Image
            preview={false}
            src={robotLogo.src}
            alt="Voice Agent"
            className="voice-agent-gif"
          />
        </button>
      </div>

      {isMounted && (
        <div
          className={`voice-agent-overlay${isOpen ? " open" : ""}`}
          onClick={closeDrawer}
        >
          <div
            className={`voice-agent-drawer${isOpen ? " open" : ""}`}
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Voice support"
          >
            <VoiceAgentPanel onClose={closeDrawer} engine={engine} />
          </div>
        </div>
      )}
    </>
  );
};

export default VoiceAgentButton;
